<template>
  <div>
    <div class="content-list">
      <h2>乘客/航程信息</h2>
      <div v-for="(air,index) in detailData.passengerList" :key="index">
        <div>
          <div class="passenger-list fs13">
            <span>乘客姓名：{{air.psgName}}</span>
            <span>乘客类型：{{air.psgTypeText}}</span>
            <span>证件类型：{{air.cardTypeText}}</span>
            <span>证件号码：{{air.cardNo}}</span>
          </div>
        </div>
        <div class="tb_box">
          <div class="tb_title">
            <span>航段</span>
            <span>航空公司</span>
            <span>航班号</span>
            <span>舱位</span>
            <span style="width:12%">起抵地</span>
            <span style="width:12%">起飞时间</span>
            <span style="width:12%">到达时间</span>
            <span>票号</span>
            <span>成人票号</span>
            <span>操作</span>
          </div>
          <div class="tb_content" v-for=" (changAir,sindex) in air.changeSegmentList" :key="sindex">
            <span>{{changAir.segmentTypeText}}</span>
            <span>{{changAir.airlineName}}</span>
            <span>{{changAir.flightNo}}</span>
            <span>{{changAir.cabinCode}}</span>
            <span style="width:12%">
              {{changAir.sCityName + changAir.sAirportCode}} -
              {{changAir.eCityName + changAir.eAirportCode}}
            </span>
            <span style="width:12%">
              {{ changAir.beginDate}}
              {{changAir.beginTime}}
            </span>
            <span style="width:12%">
              {{ changAir.arriveDate}}
              {{changAir.arriveTime}}
            </span>
            <span>{{changAir.ticketNumber}}</span>
            <span>{{changAir.aduTicketNumber}}</span>
            <span
              class="btn"
              @click="tableShow = index+'-'+sindex,getAir(changAir,sindex),arrIndex = sindex"
            >选择改签航班</span>
            <div v-show="tableShow == index+'-'+sindex" class="clear">
              <table-fligth
                :getChildAirInfo="(val,btnShow)=>getChildAirInfo({val,btnShow,air,changAir})"
                :flights="flights"
                :arrIndex="arrIndex"
                @activeBtn="activeBtn"
              ></table-fligth>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import tableFligth from "./table-fligth";
import childrenChangeFlight from "@/lib/data-service/flight/newFligthApi/buyer_dom_manage_childrenChangeFlight";

export default {
  name: "childTicket",
  data() {
    return {
      tableShow: "",
      flights: [],
      arrIndex: null
    };
  },
  props: {
    detailData: Object,
    getChildAirInfo: {
      type: Function,
      default: () => {
        return "start";
      }
    }
  },
  components: { tableFligth },
  methods: {
    activeBtn(val) {
      console.log("接收", val);
    },
    getAir(val) {
      let data = {
        // orderNo: this.$route.query.ordersNo,
        aduTicketNumber: val.aduTicketNumber
      };
      childrenChangeFlight(data).then(res => {
        this.flights.map(item => {
          item.btnShow ? (item.btnShow = true) : (item.btnShow = false);
          item.btnStop = false;
        });
        this.flights = res.flights;
      });
    }
  }
};
</script>
<style lang="less" scoped>
@import "~@/lib/deprecated/styles/common.less";

.content-list {
  @contentBox();
  .el-table {
    font-size: 13px;
  }
}

.passenger-list {
  padding: 10px 25px;
  background: #ecf6ff6e;
  font-weight: 400;
  border-bottom: 1px dashed #dfdfdf;
  span {
    padding-right: 40px;
  }
}
.fs13 {
  p {
    padding: 5px 0;
  }
}
.tb_box {
  font-size: 13px;
  text-align: center;
  .tb_title {
    padding: 12px 0;
    display: flex;
    background: #ecf6ff;
    span {
      width: 9%;
    }
  }
  .tb_content {
    // padding: 8px 0;
    border-bottom: 1px solid #dfdfdf;
    &::after {
      content: "";
      display: block;
      clear: both;
    }
    span {
      display: block;
      float: left;
      overflow: hidden;
      word-wrap: break-word;
      width: 9%;
      min-height: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      // border-right: 1px solid #dfdfdf;
    }
    .btn {
      color: #409eff;
      cursor: pointer;
    }
  }
}
</style>
